const SCI = require('sci')

const routerBuilder = require('./router')

SCI.bootVueRouter(routerBuilder)



// WEBPACK FOOTER //
// ./resources/assets/javascript/routes/terms/index.js